module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-info-block"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.blockTitle))]), _vm._v(" "), _c('div', {
    staticClass: "content lateral-sub-padding"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f2fabdc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderInfoBlock.vue
// module id = 302
// module chunks = 2